import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

export const useActions = () => {
  const dispatch: Dispatch<any> = useDispatch();
  return {};
};
